module.exports = __webpack_public_path__ + "static/media/adobexd.eba01fc3.svg";